var _ = require('underscore');
var xtend = require('xtend');
var format = require('date-fns/format');
import qs from '../../../utils/QueryString'

var whitelist = [
    'resultPage',
    'tab',
    'eventID',
    'getOnlyPrivate',
    'liveOnly',
    'resultMax',
    'sortBy',
    'startDateTime',
    'stopDateTime',
];

var searchFields = ['title', 'description', 'anyCategories', 'location',
    'keywords'];

function _createParams (_req, _defaults) {
    var req = _.pick(_req, whitelist.concat(searchFields));
    var defaults = xtend(_.pick(_defaults, whitelist), {
        startDateTime: format(_defaults.startDateTime, 'YYYY-MM-DD'),//.toISOString(),
        stopDateTime: format(_defaults.stopDateTime, 'YYYY-MM-DD')//.toISOString()
    });
    const acc = {}
    Object.keys(req).forEach(key => {
        const val = req[key]
        if (val !== defaults[key]) {
            acc[key] = val
        }
    })

    if (acc.liveOnly === 'true') {
        // make boolean
        acc.liveOnly = true
    }
    if (acc.getOnlyPrivate === 'true') {
        acc.getOnlyPrivate = true
    }
    if ((acc.stopDateTime || acc.startDateTime) && !(acc.stopDateTime && acc.startDateTime)) {
        // one of the dates is missing
        if (!acc.stopDateTime) {
            acc.stopDateTime = defaults.stopDateTime
        } else {
            acc.startDateTime = defaults.startDateTime
        }
    }
    return acc
}

var QueryStringIO = function (req, defaultParams) {
    defaultParams = defaultParams || {};
    qs.set(_createParams(req, defaultParams));
};

QueryStringIO._createParams = _createParams;  // so we can test this

export default QueryStringIO
